// Текст, поданный руками, а не транскрибацией: вставка из буфера обмена или файл.
//
// Имя вставленного текста одно на всех — по нему запись в истории не отличить от
// соседних, поэтому оно же служит признаком «имя ничего не значит, можно назвать
// по содержанию» (см. composeTitle в autoTitle.js). Имя файла, наоборот, осмысленное
// и не трогается.
export const PASTED_SOURCE_NAME = 'Вставленный текст';
